import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { TradeAreaIcon } from 'src/components/insights/icons/trade-area'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import InsightLocked from 'src/components/insight-locked'
import { useTier } from 'src/hooks/use-tier'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'

import ttaPreview1 from 'src/assets/images/insights-previews/true-trade-area/tta_1.gif'
import ttaPreview1Placeholder from 'src/assets/images/insights-previews/true-trade-area/tta_1.png'
import ttaPreview2 from 'src/assets/images/insights-previews/true-trade-area/tta_2.gif'
import ttaPreview2Placeholder from 'src/assets/images/insights-previews/true-trade-area/tta_2.png'
import ttaPreview3 from 'src/assets/images/insights-previews/true-trade-area/tta_3.gif'
import ttaPreview3Placeholder from 'src/assets/images/insights-previews/true-trade-area/tta_3.png'
import { Colors } from 'src/components/theme'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const TrueTradeAreaContent = dynamic(() => import('src/components/insights/true-trade-area/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const TrueTradeAreaPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const meetsTier = useTier(INSIGHTS_TIER['True Trade Area'])

  return (
    <InsightContainer insight={insight} color={Colors.purpleDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        {!meetsTier ? <InsightLocked insight={insight} /> : <TrueTradeAreaContent />}
      </React.Suspense>
    </InsightContainer>
  )
}

export const TrueTradeArea: Insight = {
  id: 'true-trade-area',
  tabId: COMMANDAI_IDS_MAP.mapExplorer['true-trade-area-insights-tab'],
  component: TrueTradeAreaPage,
  name: 'True Trade Area',
  icon: TradeAreaIcon,
  supportedResultTypes: ['alphamap-location'],
  linkTooltipFile: 'insights-link-location-visits',
  tier: INSIGHTS_TIER['True Trade Area'],
  paywall: {
    title: 'See True Trade Area Reports in Action',
    description: `True Trade Area isn't available on your current plan. However, you can view full functionality of this feature by viewing an unlocked location or upgrading your plan below.`,
    synopsis: [
      {
        image: ttaPreview1.src,
        imagePlaceholder: ttaPreview1Placeholder.src,
        title: 'Discover the Real Reach of Your Brand',
        description: 'Uncover the geographical spread of your customers with our in-depth trade area insights.',
      },
      {
        image: ttaPreview2.src,
        imagePlaceholder: ttaPreview2Placeholder.src,
        title: 'Strategize Expansion with Confidence',
        description:
          'Smartly navigate expansion and assess competitive landscapes, making informed decisions about where to grow.',
      },
      {
        image: ttaPreview3.src,
        imagePlaceholder: ttaPreview3Placeholder.src,
        title: 'Gain a Competitive Edge',
        description:
          'Quickly identify customer overlaps with competitors, leveraging TTA for strategic business positioning and smarter market moves.',
      },
    ],
  },
}
